import { render } from "./NotFound.vue?vue&type=template&id=396ad9db&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=396ad9db&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396ad9db"]])

export default __exports__